import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_AWARD_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateAwardSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_AWARD_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateAwardSimpleDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.awards.award)

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_AWARD_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateAwardSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_AWARD_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateAwardSimpleDetailsMutation
